@if (field.label) {
  <div class="form-field__label form-field__label--external">
    {{ field.label | translateInline }}
  </div>
}
<div [class.form-field__signature--modal]="showAsModal">
  <div class="form-field__signature-wrapper">
    <div
      class="form-field__signature-canvas_wrapper"
      [class.form-field__signature-canvas_wrapper--error]="showError"
    >
      <canvas nextSignaturePad (update)="updateValue($event)"></canvas>
    </div>
    <div class="form-field__signature-bar">
      <div class="form-field__signature-buttons">
        <button
          type="button"
          class="form-button form-field__signature-button form-field__signature-button--clear"
          (click)="clearValue()"
        >
          {{ 'clear_signature' | translate }}
        </button>

        <button
          type="button"
          class="form-button gray form-field__signature-button form-field__signature-button--fullscreen"
          (click)="toggleModal()"
        >
          <fa-icon
            [icon]="showAsModal ? _iconHideFullscreen : _iconShowFullscreen"
          ></fa-icon>
          <span>{{
            (showAsModal ? 'done' : 'fullscreen_mode') | translate
          }}</span>
        </button>
      </div>
      <div class="form-field__signature-validation">
        @if (!value) {
          <div>{{ 'sign_above' | translate }}</div>
        } @else {
          <div>{{ 'thank_you' | translate }}</div>
        }
      </div>
    </div>
    <div class="form-field__error-message">
      @if (showError && control.errors) {
        <div>
          {{ control.errors | declarativeErrorMessage: field : declaration }}
        </div>
      }
    </div>
  </div>
</div>
